import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Solo con celular funciona?',
    a: 'Sí, CapCut móvil es profesional: 1080p, sin watermark. Todo el sistema está diseñado para hacerse desde tu teléfono.'
  }, {
    q: '¿Hay clientes reales?',
    a: 'Sí. Incluimos 100 grupos de Facebook de latinas en Houston, Miami y más donde los dueños de negocios buscan ayuda.'
  }, {
    q: '¿Y los impuestos?',
    a: 'Incluimos guía de tracking con QuickBooks free y recursos IRS en español para que estés tranquila.'
  }, {
    q: '¿Si no me gusta editar?',
    a: '1 revisión gratis incluida en el contrato template. El sistema te enseña a filtrar clientes difíciles.'
  }, {
    q: '¿Cuánto tiempo para llegar a $500?',
    a: '1 hora por noche, 4 semanas consistentes siguiendo el plan paso a paso.'
  }, {
    q: '¿CapCut es realmente gratis?',
    a: 'Sí, para siempre. Exporta sin watermark. No necesitas pagar la versión Pro para empezar.'
  }, {
    q: '¿Zelle es seguro?',
    a: 'Es el estándar de pago entre latinas en USA. Te enseñamos a cobrar por adelantado o 50/50.'
  }];
  return <section className="py-20 bg-white" data-id="element-23">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-25">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-[#D4A853]/10 rounded-full mb-4 text-[#D4A853]" data-id="element-26">
            <HelpCircle className="w-6 h-6" data-id="element-27" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B0E]" data-id="element-28">
            🤔 Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-30" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="border border-gray-200 rounded-2xl overflow-hidden bg-[#FFF8F0]/50 hover:bg-[#FFF8F0] transition-colors" data-id="element-31">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-32">
        <span className="text-lg font-bold text-[#2D1B0E]" data-id="element-33">{question}</span>
        <ChevronDown className={`w-5 h-5 text-[#D4A853] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
      </button>
      <AnimatePresence data-id="element-35">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-36">
            <div className="px-6 pb-6 text-[#2D1B0E]/80 leading-relaxed" data-id="element-37">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}